<div>
  <div
    *ngIf="gridData | async"
    class="uk-card uk-card-default uk-margin-large-right uk-margin-medium-bottom"
    style="margin-top: 15px"
  >
  <div class="uk-card-header uk-padding-small uk-background-muted uk-flex uk-flex-middle">
    <div class="uk-width-expand">
      <h3
        id="planification"
        class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted"
      >
        Planification
      </h3>
    </div>
    <div>
      <button
        *ngIf="gestionTranchesIntervenant.b_actif && !bOst"
        (click)="resetData()"
        [svgIcon]="svgTableAdd"
        class="uk-button uk-button-default"
        kendoButton class="k-button k-primary" 
      >
      </button>
    </div>
  </div>
    <div class="uk-card-body uk-padding-remove">
      <kendo-grid
        [data]="gridData | async"
        [rowClass]="shade"
        [height]="533"
        (cellClick)="cellClickHandler($event)"
        [navigable]="true"
        (remove)="deleteTranche($event)"
      >
        <ng-template kendoGridNoRecordsTemplate>
          Aucune planification pour cette session
        </ng-template>
        <kendo-grid-column field="date_session" title="Date"> </kendo-grid-column>
        <kendo-grid-column field="tranche" title="Tranche"> </kendo-grid-column>
        <kendo-grid-column field="horaires" title="Horaires"> </kendo-grid-column>
        <kendo-grid-column field="site" title="Site"> </kendo-grid-column>
        <kendo-grid-column field="nom" title="Intervenant(s)"> </kendo-grid-column>
        <kendo-grid-command-column *ngIf="gestionTranchesIntervenant.b_actif && !bOst">
          <ng-template kendoGridCellTemplate>
            <button kendoGridRemoveCommand><span class="colored-text" uk-icon="icon: trash"></span></button>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid>
    </div>
  </div>
</div>

<kendo-dialog 
  *ngIf="dialogOpened"
  (close)="dialogOpened = false"
  title="Tranche horaire">
    <div uk-grid class="uk-child-width-1-3">
      <div>
        <label>Date</label>
        <div>
          <kendo-datepicker
            [format]="'dd/MM/yyyy'"
            [(ngModel)]="dateTranche"
            class="dateAppJust"
            required
          >
          <kendo-datepicker-messages today="Aujourd'hui"></kendo-datepicker-messages>
        </kendo-datepicker>
        </div>
      </div>
      <div>
        <p class="uk-margin-remove">Tranche</p>
        <kendo-dropdownlist
          required
          [(ngModel)]="typeTranche"
          [data]="listItems"
          [textField]="'type'"
          [valueField]="'id'"
          (valueChange)="loadDefaultHours($event)"
        >
        </kendo-dropdownlist>
      </div>
      <div>
        <p class="uk-margin-remove">Sites</p>
        <kendo-dropdownlist
          required
          [data]="listSites"
          [textField]="'affichage_combo'"
          [valueField]="'id'"
          [(ngModel)]="site"
        >
        </kendo-dropdownlist>
      </div>
      <div>
        <label>Heure début</label>
        <div>
          <kendo-timepicker [(ngModel)]="heureDebutTranche" class="dateAppJust" required>
            <kendo-datetimepicker-messages 
              today="Maintenant" 
              now="Maintenant" 
              accept="Accepter"
              cancel="Annuler">
            </kendo-datetimepicker-messages>
          </kendo-timepicker>
        </div>
      </div>
      <div>
        <label>Heure fin</label>
        <div>
          <kendo-timepicker [(ngModel)]="heureFinTranche" class="dateAppJust" required>
            <kendo-datetimepicker-messages 
              today="Maintenant" 
              now="Maintenant" 
              accept="Accepter"
              cancel="Annuler">
            </kendo-datetimepicker-messages>
          </kendo-timepicker>
        </div>
      </div>
    </div>
    <kendo-dialog-actions>
      <button
        kendoButton
        class="k-button k-primary" 
        (click)="saveTranche($event)"
      >
        Valider
        <ng-template #loading>CHARGEMENT...</ng-template>
      </button>
    </kendo-dialog-actions>
</kendo-dialog>